import React from "react"

import FramedLayout from "~layouts/FramedLayout"

import Footer from "~components/Footer"
import * as style from "./IndexLayout.module.scss"

const IndexLayout = ({ children }) => (
  <FramedLayout showHeader showSearch>
    <section className={style.layout}>
      {children}
      <Footer alignment="wide" />
    </section>
  </FramedLayout>
)

export default IndexLayout
